module.exports = __webpack_public_path__ + "img/bg1.cf1d388c.png";